import { render, staticRenderFns } from "./CardCostExpandTable.vue?vue&type=template&id=c13873a0&"
import script from "./CardCostExpandTable.vue?vue&type=script&lang=ts&"
export * from "./CardCostExpandTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports